import React, { Component } from "react";
import Modal from "react-modal";
import { NavLink } from "react-router-dom";

import HamburgerIcon from "icons/HamburgerIcon";
import CloseIcon from "icons/CloseIcon";

class HomeNavigation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  openMenu = (e) => {
    this.setState({ isOpen: true });
    e.stopPropagation();
  };

  closeMenu = (e) => {
    this.setState({ isOpen: false });
    if (e) {
      e.stopPropagation();
    }
  };

  render() {
    return (
      <div className="navigation">
        <div className="icon" onClick={this.openMenu}>
          <HamburgerIcon />
        </div>
        <Modal
          ariaHideApp={false}
          isOpen={this.state.isOpen}
          closeTimeoutMS={400}
          onRequestClose={this.closeMenu}
          className={{
            base: "navigation-modal",
            afterOpen: "navigation-modal-after-open",
            beforeClose: "navigation-modal-before-close",
          }}
          overlayClassName={{
            base: "navigation-modal-overlay",
            afterOpen: "navigation-modal-overlay-after-open",
            beforeClose: "navigation-modal-overlay-before-close",
          }}
          contentLabel="Navigation Menu"
        >
          <div className="close-button" onClick={this.closeMenu}>
            <CloseIcon />
          </div>
          <div className="content">
            <ul>
              <li>
                <a href="#upcoming-meets" onClick={this.closeMenu}>
                  Upcoming Meets
                </a>
              </li>
              <li>
                <a href="#recent-meets" onClick={this.closeMenu}>
                  Recent Meets
                </a>
              </li>
              <li>
                <a href="#your-meets" onClick={this.closeMenu}>
                  Your Meets
                </a>
              </li>
              <li>
                <a href="#features" onClick={this.closeMenu}>
                  Features
                </a>
              </li>
              <li>
                <NavLink to="/about" onClick={this.closeMenu}>
                  FAQ
                </NavLink>
              </li>
              <li>
                <NavLink to="/instructions" onClick={this.closeMenu}>
                  Meet Director Instructions
                </NavLink>
              </li>
              <li>
                <NavLink to="/coach" onClick={this.closeMenu}>
                  Coach / Lifter Instructions
                </NavLink>
              </li>
              <li>
                <a href="/changes.html">Changelog</a>
              </li>
              <li>
                <NavLink to="/contact" onClick={this.closeMenu}>
                  Contact
                </NavLink>
              </li>
            </ul>
          </div>
        </Modal>
      </div>
    );
  }
}

export default HomeNavigation;
